import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/material";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useRef } from "react";

interface Props {
    onChange: (file: File) => void,
    title: string,
    loading: boolean
}

const ButtonUploadCsv = ({ onChange, title, loading }: Props) => {
    const ref = useRef<HTMLInputElement>(null);

    return (
        <Box>
            <input
                ref={ref}
                type="file"
                accept=".csv"
                onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                    e.currentTarget.value = '';
                }}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e.target.files && e.target.files[0]) {
                        onChange(e.target.files[0]);
                    }
                }}
                style={{ display: 'none' }}
            />

            <LoadingButton
                loading={loading}
                onClick={() => {
                    if (ref.current) {
                        ref.current.click();
                    }
                }}
                variant="contained"
                color="secondary"
                sx={{ textTransform: 'none', color: 'white' }}
            >
                <FileUploadIcon />&nbsp; {title}
            </LoadingButton>
        </Box>
    );
}

export default ButtonUploadCsv;